import type { DriveStep } from 'driver.js'
import { startGuidedTour } from '~/components/Global/Onboarding/startGuidedTour'

export const useDashboardOnboarding = () => {
  const steps: DriveStep[] = [
    {
      popover: {
        title: 'Bienvenue sur votre nouveau tableau de bord ! 🎉',
        description:
          'Découvrez une interface modernisée et personnalisable. Ce rapide tutoriel vous guidera à travers les nouvelles fonctionnalités.',
        side: 'bottom',
        align: 'center'
      }
    },
    {
      element: '[data-onboarding="target-toggle"]',
      popover: {
        title: 'Vue personnelle ou agence',
        description:
          'Basculez entre votre vue personnelle et celle de votre agence pour avoir une vision globale ou ciblée.',
        side: 'left',
        align: 'start'
      }
    },
    {
      element: '[data-onboarding="config-button"]',
      popover: {
        title: 'Personnalisez votre tableau de bord',
        description:
          "Organisez vos blocs comme vous le souhaitez : réorganisez-les par glisser-déposer, masquez ceux dont vous n'avez pas besoin.",
        side: 'left',
        align: 'start'
      }
    },
    {
      element: '[data-onboarding="main-blocks"]',
      popover: {
        title: 'Vos blocs principaux',
        description:
          'Retrouvez vos dernières candidatures, vos prochaines actions et vos commandes ouvertes. Chaque bloc est personnalisable.',
        side: 'right',
        align: 'start'
      }
    },
    {
      element: '[data-onboarding="next-actions-config"]',
      popover: {
        title: 'Configuration des actions',
        description:
          "Configurez les actions que vous souhaitez afficher dans ce bloc, vous pouvez même choisir d'afficher les actions prévues passées.",
        side: 'left',
        align: 'start'
      }
    },
    {
      element: '[data-onboarding="applicant-experiences-config"]',
      popover: {
        title: 'Contrats à renouveler',
        description: 'Consulter rapidement les contrats à renouveler.',
        side: 'left',
        align: 'start'
      }
    },
    {
      element: '[data-onboarding="last-activity"]',
      popover: {
        title: 'Dernières activités',
        description:
          "Consultez rapidement les derniers éléments créés pour ne rien manquer. Filtrez par type d'élément pour ne voir que ceux que vous souhaitez.",
        side: 'left',
        align: 'start'
      }
    },
    {
      popover: {
        title: 'Vous êtes prêt ! 🚀',
        description:
          'Vous pouvez relancer ce tutoriel à tout moment depuis les paramètres du tableau de bord. Bonne utilisation !',
        side: 'top',
        align: 'center'
      }
    }
  ]

  const startTour = () => {
    startGuidedTour(steps)
  }

  return {
    startTour
  }
}
